var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBellRinging = function SvgIconBellRinging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.935 2.46A1 1 0 1 0 5.872.766 11.4 11.4 0 0 0 1.68 5.43a1 1 0 0 0 1.797.877A9.4 9.4 0 0 1 6.935 2.46M16.75 1.081a1 1 0 0 1 1.378-.315 11.4 11.4 0 0 1 4.193 4.664 1 1 0 1 1-1.798.877 9.4 9.4 0 0 0-3.458-3.847 1 1 0 0 1-.315-1.379"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.008 19H4.591a1.75 1.75 0 0 1-1.51-2.625l.001-.001c.515-.89 1.187-2.66 1.187-5.874a7.731 7.731 0 1 1 15.463 0c0 3.215.672 4.985 1.187 5.874v.001A1.75 1.75 0 0 1 19.41 19h-3.418a4 4 0 0 1-7.984 0m1.8-13.795a5.73 5.73 0 0 1 7.924 5.295c0 3.169.602 5.215 1.253 6.5H5.016c.651-1.285 1.253-3.331 1.253-6.5a5.73 5.73 0 0 1 3.538-5.295M10.015 19a2 2 0 0 0 3.969 0z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBellRinging;